import React from 'react';

const CircleCloseIcon = () => (
  <svg
    width="17px"
    height="17px"
    viewBox="0 0 17 17"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-480.000000, -38.000000)"
        fill="#FFFFFF"
        fillOpacity="0.57"
        fillRule="nonzero"
      >
        <g transform="translate(225.000000, -3.000000)">
          <path d="M257.382812,43.7578125 C258.971362,42.1692629 260.885405,41.375 263.125,41.375 C265.364595,41.375 267.278638,42.1692629 268.867188,43.7578125 C270.455737,45.3463621 271.25,47.2604055 271.25,49.5 C271.25,51.7395945 270.455737,53.6536379 268.867188,55.2421875 C267.278638,56.8307371 265.364595,57.625 263.125,57.625 C260.885405,57.625 258.971362,56.8307371 257.382812,55.2421875 C255.794263,53.6536379 255,51.7395945 255,49.5 C255,47.2604055 255.794263,45.3463621 257.382812,43.7578125 Z M267.1875,52.4296875 L264.257812,49.5 L267.1875,46.5703125 L266.054688,45.4375 L263.125,48.3671875 L260.195312,45.4375 L259.0625,46.5703125 L261.992188,49.5 L259.0625,52.4296875 L260.195312,53.5625 L263.125,50.6328125 L266.054688,53.5625 L267.1875,52.4296875 Z"></path>
        </g>
      </g>
    </g>
  </svg>
);

export default CircleCloseIcon;
